module.exports = __webpack_public_path__ + "static/img/pe-ride.f26f30a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/pe-ride.png
// module id = Qj//
// module chunks = 0